import { useContext } from "react";

import { ModalPackageForm } from "common/contexts";

const Step2 = () => {
  const { register, isSubmitting, errors } = useContext(ModalPackageForm);

  return (
    <div className="m-auto max-w-xs text-left">
      <input
        {...register("first_name", {
          required: {
            value: true,
            message: "This field is required",
          },
        })}
        className={
          " mt-6  w-full rounded-full border-0 px-4  py-2  text-bbc-gray focus:outline-none"
        }
        required
        disabled={isSubmitting}
        type="text"
        placeholder="Your Full Name"
      />

      <span className="block pt-2 pl-2 text-sm text-red-500">
        {errors.first_name?.message}
      </span>

      <input
        type="email"
        {...register("email", {
          required: {
            value: true,
            message: "Email is required",
          },
          pattern: {
            value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
            message: "Invalid e-mail",
          },
        })}
        placeholder="Your Email:"
        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
        className=" mt-6  w-full rounded-full border-0 px-4  py-2  text-bbc-gray transition-colors
                                          duration-200 invalid:border-pink-500 invalid:text-pink-600
                                          focus:bg-white focus:outline-none
                                          focus:outline-hidden focus:ring-0
                                          focus:invalid:border-pink-500 focus:invalid:ring-pink-500"
      />

      <span className="block pt-2 pl-2 text-sm text-red-500">
        {errors.email?.message}
      </span>
    </div>
  );
};

export default Step2;
